



































































import { Vue, Component } from 'vue-property-decorator';
import FormKeyword from '@/components/common/searchForm/FormKeyword.vue';
import { hasSize, selectBoxOption } from '@/views/promotion/freeGift/conditionList/FreeGiftCondition';
import FormButtons from '@/components/common/searchForm/FormButtons.vue';
import FormAutoComplete from '@/components/common/searchForm/FormAutoComplete.vue';
import { GetOptionsStocks, Nullable } from 'supporter';
import { KeywordData } from '@/types';
import {
  gridPops, optionSearchKeys,
} from '@/views/promotion/popup/PromotionOptionPopSearch';
import ItemTable from '@/components/common/ItemTable.vue';
import { i18nFreeGift } from '@/views/promotion/freeGift/FreeGift';
import { OptionInfo } from '@/types/promotion';
import { pick } from 'underscore';
import { OptionsStocksParams } from 'ncp-api-supporter/dist/types/modules/product/stock';
import { intersection } from 'underscore';
import { ContractedPartner } from 'ncp-api-supporter/dist/types/modules/admin/mall';

interface SelectedOptionsValidationResult { success: number; failure: number; message: string; }

@Component({
  components: { ItemTable, FormAutoComplete, FormButtons, FormKeyword },
})
export default class PromotionOptionPopSearch extends Vue {
  private readonly i18nFreeGift = i18nFreeGift;
  private readonly selectBoxOptions = selectBoxOption.option;
  
  private productUrl = '';
  
  private keywordType = 'PRODUCT_NAME';
  private keyword = '';
  
  private partners: KeywordData[] = [];
  private selectedPartnerNo: Nullable<number> = null;
  
  private options: OptionInfo[] = [];
  private totalCount = 0;
  private page = 1;
  private size = 30;
  private gridProps = { ...gridPops(this.productUrl) };
  
  private get mallNo(): number {
    return Number(this.$route.query.mallNo);
  }
  
  private get title(): string {
    return this.$route.query.title.toString();
  }
  
  private get maxSize(): Nullable<number> {
    const size = this.$route.query?.maxSize
    return size ? Number(size) : null;
  }
  
  private get alreadySelectedNos(): number[] {
    const nos = this.$route.query?.selectedNos ?? '';
    return `${nos}`.split(',')?.filter(Boolean).map(no => Number(no));
  }
  
  private handleSearch() {
    const params: OptionsStocksParams = {
      mallNos: this.mallNo.toString(),
      partnerNo: this.selectedPartnerNo,
      categoryType: 'DISPLAY_CATEGORY',
      periodType: 'REGISTER_YMDT',
      searchKeywordType: this.keywordType,
      keyword: this.keyword,
      platformDisplayType: 'NONE',
      saleStatusTypes: 'ON_PRE_SALE,ON_SALE',
      saleSettingStatusTypes: 'AVAILABLE_FOR_SALE',
      freeGiftAvailable: true,
      page: this.page,
      size: this.size,
    }
		
		this.gridProps.options.pageOptions.page = this.page;
		this.gridProps.options.pageOptions.perPage = this.size;
  
		this.$api.getOptionsStocks({ params }).then(({ data }) => this.setOptions(data));
  }
  
  private setOptions(data: GetOptionsStocks) {
    this.options = data.stockViews.map(({ mallProductNo, mallOptionNo, applyDiscountSalePrice, applyOptionAddPrice, ...rest }) => {
      return {
        ...pick(rest, optionSearchKeys),
        productNo: mallProductNo,
        optionNo: mallOptionNo,
        appliedAdditionalDiscountPrice: applyDiscountSalePrice,
        optionPrice: applyOptionAddPrice,
      } as OptionInfo
    });
    
    this.totalCount = data.mallProductCount;
  }
  
  private handleReset() {
    this.keywordType = 'PRODUCT_NAME';
    this.keyword = '';
    this.selectedPartnerNo = null;
    this.resetData(1, this.gridProps.options.pageOptions.perPage);
  }
  
  private isInit = true;
  private resetData(page: number, size?: number) {
    if (this.isInit) {
      this.isInit = false;
      return;
    }
  
    this.page = page;
    
    if (size) {
      this.size = size;
    }
    
    this.handleSearch();
  }
  
  private selectedPartner(no: Nullable<number>) {
    this.selectedPartnerNo = no;
  }
  
  private handleSelectedOptions() {
    const selectedOptions = ((this.$refs.gridRef as ItemTable).getCheckedRows()) as any as OptionInfo[];
    
    if (!this.canSendPostMessage(selectedOptions)) return;
    
    this.alertToAddSelectedOptions(selectedOptions);
    this.setPostMessage(selectedOptions);
  }
  
  private canSendPostMessage(selectedOptions: OptionInfo[]): boolean {
    if (!hasSize(selectedOptions)) {
      alert(i18nFreeGift('ALERT_NO_SELECTED_OPTION'));
      return false
    }
    return true
  }
  
  private checkSelectedOptions(selectedOptions: OptionInfo[]): SelectedOptionsValidationResult {
    const alreadySelectedNosCount = this.alreadySelectedNos.length;
    const totalCount = alreadySelectedNosCount + selectedOptions.length;
    const result: SelectedOptionsValidationResult = {
      success: totalCount,
      failure: 0,
      message: 'ALERT_ADDED'
    }
  
    if (hasSize(this.alreadySelectedNos) && totalCount <= this.maxSize) {
      const selectedOptionNos = selectedOptions.map(({ optionNo }) => optionNo);
      result.failure = intersection(this.alreadySelectedNos, selectedOptionNos).length;
      result.success = totalCount - result.failure - alreadySelectedNosCount;
      return result
    }
  
    if (totalCount > this.maxSize) {
      result.success = this.maxSize;
      result.message = 'ALERT_MAX_SIZE_OPTIONS';
      return result;
    }
  
    return result;
  }
  
  private alertToAddSelectedOptions(selectedOptions: OptionInfo[]) {
    const { message, ...rest } = this.checkSelectedOptions(selectedOptions);
    alert(this.$t(i18nFreeGift(message, true), rest));
  }
  
  private setPostMessage(options: OptionInfo[]) {
    window.opener.postMessage({ options });
    this.close();
  }
  
  private close() {
    window.close();
  }
  
  private promotionResultReceiver(event: MessageEvent) {
    const data = event.data;
    if (data?.freeGiftType !== 'freeGiftOption') return;
    
    this.handleSearch();
    this.bindMessageEvent('remove');
  }
  
  private bindMessageEvent(type: 'add' | 'remove') {
    window[`${type}EventListener`]('message', this.promotionResultReceiver);
  }
  
  private created() {
    this.bindMessageEvent('add');
    this.fetchPartners();
    this.fetchProductUrl();
    this.setGridPropsColumns();
  }
  
  private setGridPropsColumns() {
    this.size = this.gridProps.options.pageOptions.perPage;
  }
  
  private fetchProductUrl() {
    this.$api.getMallsConfigurations({
      pathParams: { mallNo: this.mallNo.toString()},
      params: { key: 'MALL_PRODUCT'}
    }).then(({ data }) => this.productUrl = data.productDetailUrl)
  }
  
  private fetchPartners() {
  
    this.$api.getMallsContractedPartnersByMallNo({
      pathParams: {
        mallNo: `${this.mallNo}`
      }
    }).then(({ data }) => {
      const filteredPartners = data.filter(item => {
        return item.partnerStatus === 'ACTIVE' && ( item.contractStatus === 'ACTIVE' || item.contractStatus === 'SUSPEND' );
      });
      return this.mapPartners(filteredPartners)
    })
  }
  
  private mapPartners(partners: ContractedPartner[]) {
    this.partners = partners.map(({ partnerNo: no, partnerName: label }) => ({ no, label }));
  }
}

